import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import ShareListing from './ShareListing/ShareListing';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const {
    listing,
    variantPrefix,
    shareUrl,
    shareTitle,
    shareImageUrl,
    onManageDisableScrolling,
  } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
      />
      {shareUrl ? (
        <ShareListing
          className={css.shareListingButton}
          url={shareUrl}
          title={shareTitle}
          imageUrl={shareImageUrl}
          onManageDisableScrolling={onManageDisableScrolling}
        />
      ) : null}
    </section>
  );
};

export default SectionGallery;
